import { getURLSearchParams } from '@web-platform/shared-banana-utils-frontend/src/helpers/getURLSearchParams';
import {
  HOMEPAGE_NAV_CARD_1_SLOT_ID,
  HOMEPAGE_NAV_CARD_2_SLOT_ID,
  HOMEPAGE_NAV_CARD_3_SLOT_ID,
  HOMEPAGE_NAV_CARD_4_SLOT_ID,
  HOMEPAGE_NAV_CARD_5_SLOT_ID,
  HOMEPAGE_NAV_CARD_6_SLOT_ID,
  HOMEPAGE_NAV_CARD_7_SLOT_ID,
  PAGE_TYPES,
} from '@web-platform/shared-universal-constants/src/adverts';
import {
  useAdsRetrievalServiceCreativeData,
  type AdsRetrievalServiceQueryState,
} from '@web-platform/shared-universal-redux/src/network-layer/hooks/useAdsRetrievalServiceCreativeData';
import { ADS_RETRIEVAL_SERVICE_NAVCARD } from '@web-platform/shared-universal-types/src/network/requestTypes';

export const useGlobalNavData = (): AdsRetrievalServiceQueryState => {
  const creativeId = getURLSearchParams().get('navCardPreviewId') || undefined;

  const { moreDataExpected, timedOut } = useAdsRetrievalServiceCreativeData({
    creativeId,
    pageType: PAGE_TYPES.HOME,
    type: ADS_RETRIEVAL_SERVICE_NAVCARD,
    placementIds: {
      [HOMEPAGE_NAV_CARD_1_SLOT_ID]: 'mobile.flights.dynamic-home/navcards_slot1',
      [HOMEPAGE_NAV_CARD_2_SLOT_ID]: 'mobile.flights.dynamic-home/navcards_slot2',
      [HOMEPAGE_NAV_CARD_3_SLOT_ID]: 'mobile.flights.dynamic-home/navcards_slot3',
      [HOMEPAGE_NAV_CARD_4_SLOT_ID]: 'mobile.flights.dynamic-home/navcards_slot4',
      [HOMEPAGE_NAV_CARD_5_SLOT_ID]: 'mobile.flights.dynamic-home/navcards_slot5',
      [HOMEPAGE_NAV_CARD_6_SLOT_ID]: 'mobile.flights.dynamic-home/navcards_slot6',
      [HOMEPAGE_NAV_CARD_7_SLOT_ID]: 'mobile.flights.dynamic-home/navcards_slot7',
    },
  });

  return {
    moreDataExpected,
    timedOut,
  };
};
